import dateFormat from 'date-fns/format';
import {
    forwardRef,
    HTMLAttributes,
    useCallback,
    useEffect,
    useMemo,
    useState,
} from 'react';
import styled from 'styled-components';
import { useStore } from '../../../contexts/StoreContext';
import { FavoriteIcon, useFavorite } from '../../../hooks/useFavorite';
import { MovieDisplay } from '../../../utils/Video';
import { colors } from '../../const/Styles';
import {
    fromMovieDisplayToVideoMovie,
    VideoMovie,
} from '../../video/PlayingVideoCard';

import BestSwingButton from '../../base/surface/BestSwingIcon';
import Api from '../../../utils/Api';
import VideoComposer from '../../video/VideoComposer';
import { FooterButton } from '../../video/VideoComposer/Footer';

const Container = styled.article`
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
`;

const VideoContainer = styled.div`
    position: relative;s
    display: flex;
    flex-direction: row;
    height: fit-content;
    width: 100%;
    align-items: center;
    justify-content: center;
    position: relative;
    .vjs-control-bar {
        z-index: 3;
    }
    .vjs-big-play-button {
        z-index: 3;
    }
`;

const HeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 5px 0;
    font-weight: bold;
`;

const PlayerName = styled.label`
    display: block;
    font-size: 21px;
    color: ${colors.black};
    font-weight: bold;
`;

const LessonInfomation = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-conten: flex-end;
`;

const LessonInfomationColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;
    font-size: 12px;
`;

const CreatedAt = styled.div`
    text-align: right;
`;

const InlineList = styled.ul`
    display: flex;
    flex-direction: row;
    margin: 0;
    padding: 0;
    > li {
        display: block;
        box-sizing: border-box;
        padding-right: 15px;
        &:last-child {
            padding-right: 0;
        }
        &:before {
            content: '●';
        }
    }
`;


const MovieIndex = styled.span`
    margin: 0;
    padding: 0;
    margin-left: 20px;
    color: ${colors.footerIconSelected};
    font-size: 45px;
    font-weight: bold;
    line-height: 1;
`;


const FavIcon = styled(FavoriteIcon)`
    position: absolute;
    top: 67px;
    right: -65px;
    background-color: black;
`;


interface Props extends HTMLAttributes<Element> {
    movieDisplay: MovieDisplay;
    showFav?: boolean;
    showTimeLine?: boolean;
    showHeader?: boolean;
    movieIndex?: number;
    onChangeDuration?: (time: number) => void;
    showGuide?: boolean;
    onClose?: () => void;
}

export type ForwardProps = {
    advance: () => void;
    goBack: () => void;
    togglePlay: () => Promise<void>;
};

const LessonMoviePlayer = forwardRef<ForwardProps, Props>(
    ({
        movieDisplay,
        showFav = true,
        showHeader = true,
        movieIndex = undefined,
        className,
        onClose,
    }) => {
        const { tempoStore, lessonStore } = useStore();
        const videoMovie: VideoMovie =
            fromMovieDisplayToVideoMovie(movieDisplay);
        const [saveCounter, setSaveCounter] = useState<number>(0);

        const [faved, toggleFav] = useFavorite(movieDisplay);
        const { created_at, club, yards, customer_id_or_staff_id } =
            movieDisplay;

        const isCustomer = useMemo(() => {
            return typeof lessonStore.resolveCustomerName(Number(customer_id_or_staff_id)) !== 'undefined';
        }, [lessonStore, customer_id_or_staff_id])

        const userName = useMemo(() => {
            return (
                tempoStore.resolveUserName(Number(customer_id_or_staff_id)) ||
                lessonStore.resolveCustomerName(Number(customer_id_or_staff_id)) ||
                []
            );
        }, [tempoStore, lessonStore, customer_id_or_staff_id]);

        const extraButtons: FooterButton[] = [
            {
                label: '閉じる',
                onClick: () => {
                    if (onClose) {
                        onClose();
                    }
                },
            },
        ];
        return (
            <Container className={className}>
                {showHeader && (
                    <HeaderContainer>
                        <PlayerName className='userName'>
                            {userName.join(' ')}
                        </PlayerName>
                        <LessonInfomation>
                            <LessonInfomationColumn>
                                <CreatedAt>
                                    {dateFormat(
                                        new Date(created_at),
                                        'yyyy/MM/dd',
                                    )}
                                </CreatedAt>
                                <InlineList>
                                    <li>{club}</li>
                                    <li>{yards}y</li>
                                </InlineList>
                            </LessonInfomationColumn>
                            {movieIndex && (
                                <MovieIndex>{movieIndex}</MovieIndex>
                            )}
                        </LessonInfomation>
                    </HeaderContainer>
                )}
                <VideoContainer>
                    {showFav && <FavIcon faved={faved} onClick={toggleFav} />}
                    <VideoComposer
                        isBackgroundDark={false}
                        ownerId={movieDisplay.customer_id_or_staff_id}
                        toolImageFilePath={movieDisplay.tool_image_filepath}
                        movieSequence={movieIndex}
                        createdAt={movieDisplay.created_at}
                        club={movieDisplay.club}
                        yard={movieDisplay.yards}
                        isBestSwing={movieDisplay.desirable}
                        playbackPosition={movieDisplay.playback_position}
                        videoSrc={videoMovie}
                        height={601}
                        width={416}
                        saveCounter={saveCounter}
                        setSaveCounter={setSaveCounter}
                        isShowHeader={false}
                        extraButtons={extraButtons}
                        isShowBestSwing={isCustomer}
                    />
                </VideoContainer>
            </Container>
        );
    },
);

export default LessonMoviePlayer;
